// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form-input-radio .answer-val {
  padding-right: 70px;
}
form-input-radio .answer-val a.change {
  margin-right: -55px;
}
form-input-radio .answer-disabled {
  background-color: rgb(235, 235, 228);
}`, "",{"version":3,"sources":["webpack://./src/resources/elements/form-input-radio/form-input-radio.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAIE;EACE,oCAAA;AAFJ","sourcesContent":["form-input-radio {\n  .answer-val {\n    padding-right: 70px;\n\n    a.change {\n      margin-right: -55px;\n    }\n  }\n\n  .answer-disabled {\n    background-color: rgb(235, 235, 228)\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
